import { IJsonQuery } from '@cian/api-models/common/json_query';
import * as React from 'react';

import { TModifier } from '../../types/modifier';
import { ISpecialPromo } from '../../types/specialPromo';
import { IContext, context as Context } from '../../utils/context';
import { modifyJsonQuery } from '../../utils/modifyJsonQuery';

export interface IOnChangeParameters {
  appliedModifiers: [TModifier, ...TModifier[]];
  nextJsonQuery: IJsonQuery;
}

interface IProviderProps {
  jsonQuery: IJsonQuery;
  specialPromo?: ISpecialPromo;
  onChange(parameters: IOnChangeParameters): void;
  onApply(): void;
  onClear?(): void;
  onApplyClick?(): void;
  onAdvancedFiltersOpen?(): void;
}

export const Provider: React.FC<IProviderProps> = ({
  children,
  jsonQuery,
  specialPromo,
  onChange,
  onApply,
  onClear,
  onApplyClick,
  onAdvancedFiltersOpen,
}) => {
  const handleChange = React.useCallback(
    (...modifiers: [TModifier, ...TModifier[]]) => {
      onChange({
        appliedModifiers: modifiers,
        nextJsonQuery: modifyJsonQuery(jsonQuery, modifiers),
      });
    },
    [jsonQuery, onChange],
  );

  const context: IContext = {
    jsonQuery,
    specialPromo,
    onChange: handleChange,
    onApply,
    onClear,
    onApplyClick,
    onAdvancedFiltersOpen,
  };

  return <Context.Provider value={context}>{children}</Context.Provider>;
};
